module.exports = __webpack_public_path__ + "static/media/aura_supportlogo.dadcf046.png";